import * as t from '../types'
import * as a from '../actions'
import useConnect, { Config } from 'hooks/useConnect'
import { State } from '../reducer'

type Input = any

type Output = {
  data: t.CustomTailor
  getSquareM: () => number
  getAdditionalPercent: (variant: any) => number
  getSinglePrice: (price: number, variant: any) => number
  set: (type: t.CustomTailorAction, value: any) => a.SetCustomTailor
}

type DP = {
  set: typeof a.setCustomTailor
}

const getSquareM = (state): number => {
  const size = state.customTailor.size
  const SquareM = size.length
    ? size.width * size.length
    : size.width * size.width
  return SquareM / 10000
}

// calculate extra charge if additionalPricePercent is set
const getAdditionalPercent = (variant, state) => {
  const brinktype = state.customTailor.brink?.type
  if (!brinktype) return 1
  return (
    (variant.data.configurations.custom_tailor.configuration_data?.brinks.find(
      (brink) => brink.type === brinktype
    )?.additionalPricePercent || 0) + 1
  )
}

const getSinglePrice = (price, variant, state) => {
  let calc = price * getSquareM(state)
  calc = Math.ceil(calc * getAdditionalPercent(variant, state) * 100) / 100
  return calc
}

const config: Config<Input, Output, State, DP> = {
  moduleKey: 'productDetail',
  name: 'productDetail/useCustomTailor',
  createCacheKey: () => 'customTailor',
  mapState: (state) => {
    return {
      data: state.customTailor || null,
      getSinglePrice: (price, variant) => getSinglePrice(price, variant, state),
      getAdditionalPercent: (variant) => getAdditionalPercent(variant, state),
      getSquareM: () => getSquareM(state)
    }
  },
  mapDispatch: {
    set: a.setCustomTailor
  }
}

/** @firescoutMockFn productDetail.useCustomTailor */
export default function useCustomTailor(): Output {
  const input: Input = {}
  const hook: Output = useConnect(input, config)
  return hook
}
